import { Component, OnInit } from '@angular/core';
import { Meta,Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';
declare var $;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    safeURL; //youTube Video URL // 
 

    constructor(private meta: Meta,private title: Title, private _sanitizer: DomSanitizer, private metaService: MetaServiceService) {
    //  SEO Meta Description
        this.meta.addTags([
            { name: 'description', content: 'Need to create a quick survey? Use CViewSurvey Best online and offline survey applications for all types of businesses and create customized unlimited surveys to collect data anytime, anywhere.' },
            { name: 'author', content: 'CViewSurvey' },
            { 
              name: 'keywords',
              content: 'Best online survey in india  , Best offline survey in india , Best online and offline survey application , Nps for all business , Grow your business , Customized unlimited survey , Collect data from anywhere , Collect data anytime , Business growth , Take survey for client response' ,  },
        ]);

        this.setTitle('CViewSurvey | Best Online and Offline Survey | Claim Free Trial'); 
    // End SEO Meta Description

    
    // You Tube Video Description
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/O5rgp4xbB88?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description
    }
    
   
    
   // SEO Page Title Description
        public setTitle( newTitle: string) {
            this.title.setTitle( newTitle );
        }
    // SEO Page Title Description

    

    ngOnInit() {
        // for create canonical link 
        this.metaService.createCanonicalURL();

        // Owl Slider
        $(document).ready(function () {
            // Home Top Slider
            $('.owl-carousel-banner').owlCarousel({
                autoplay:true,
                autoplayTimeout:5000,
                autoplayHoverPause:true,
                loop:true,
                margin: 15,
                nav: true,
                items : 4,
                itemsDesktop : [1199,3],
                itemsDesktopSmall : [979,3],
                dots: false,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                    },
                    600: {
                        items: 1,
                        nav: false,
                    },
                    1000: {
                        items: 1
                    }
                } 
            
            });//End Home Top Slider

             // Testimonial
             $('.owl-carousel-testimonial').owlCarousel({
                loop:true,
                margin:10,
                nav:false,    
                responsiveClass:true,
                responsive:{
                    0:{
                        items:1,
                    },
                    600:{
                        items:2,
                    },
                    1000:{
                        items:1,
                    }          
                }     
            });// End Testimonial Top Slider

             // Testimonial
             $('.owl-carousel-client').owlCarousel({
                loop:true,
                margin:20,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                nav:false,  
                dots: false,  
                responsiveClass:true,
                responsive:{
                    0:{
                        items:2,
                    },
                    600:{
                        items:3,
                    },
                    1000:{
                        items:6,
                    }          
                }     
            });// End Testimonial Top Slider
        });
        // End Owl Slider

        // Accordion Toggle
        $(document).ready(function(){
            $( ".collapsed" ).mouseover(function(){
               $( this ).trigger( "click" );
            });          
        });
        // End Accordion Toggle
    }// End_ngOnInit

}
